<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form ref="form" v-bind:disabled="formSubmitted" v-on:submit.prevent="submitCode">
        <v-container>
          <v-row>
            <v-text-field
              v-model="email"
              v-bind:rules="emailRules"
              v-bind:error-messages="emailErrors"
              label="email"
              prepend-inner-icon="mdi-at"
              block
              variant="solo" flat
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              v-model="code"
              v-bind:rules="codeRules"
              label="verification code"
              prepend-inner-icon="mdi-code-tags"
              block
              variant="solo" flat
              required>
            </v-text-field>
          </v-row>

          <v-row class="mt-5">
            <v-btn type="submit" v-bind:disabled="formSubmitted" class="bg-primary" block>Verify Account</v-btn>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <div class="text-center mt-5">
      <router-link to="/account/login">Go to the login page</router-link>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import LoginLogo from './components/LoginLogo.vue'
import Helper from '@/components/helper.js';

export default {
  name: 'AccountVerify',
  components: {
    LoginLogo,
  },
  data: function() {
    return {
      email: "",
      emailErrors: [],
      emailRules: [
        v => !!v || 'Please, enter email address.',
        v => Helper.isEmailValid(v) || 'Please, enter valid email address.',
      ],

      code: "",
      codeRules: [
        v => !!v || "Please, enter verification code.",
      ],

      formSubmitted: false,
    }
  },
  methods: {
    submitCode: async function() {
      const validForm = await this.$refs.form.validate();

      if (!validForm.valid) {
        return;
      }

      const params = {
        email: this.email,
        code: this.code,
      };

      try {
        this.formSubmitted = true;
        const authStore = useAuthStore();
        await authStore.confirmSignUp(params);
        this.$router.push('/account/login');
      } catch (e) {
        this.emailErrors = e && e.message ? e.message : "General error!";
      } finally {
        this.formSubmitted = false;
      }
    }
  },
  mounted: function() {
    this.email = this.$route.params.email || '';
  }
}
</script>
